import { useMutation } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	BulkInviteAuthorisedSignatoriesPreviewRes,
	BulkDownloadFileFilters,
} from '@dealstack/shared/lib/generated';

interface BulkInviteAuthorisedSignatoriesPreviewBody {
	allDocumentsSelected: boolean;
	selectedDocumentWorkflowInstanceIds?: string[];
	excludedDocumentWorkflowInstanceIds?: string[];
	filters?: BulkDownloadFileFilters;
}

export const useBulkInviteAuthorisedSignatoriesPreview = ({
	dealId,
	programmeId,
}: {
	dealId: string;
	programmeId: string;
}) => {
	return useMutation({
		mutationFn: async (body: BulkInviteAuthorisedSignatoriesPreviewBody) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_INVITE_AUTHORISED_SIGNATORIES_PREVIEW_POST,
				{ dealId, programmeId }
			);
			return await makeRequest<ApiV1.Response<BulkInviteAuthorisedSignatoriesPreviewRes>>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});
		},
	});
};
